import React from "react";
import { injectIntl } from "react-intl";

import { Table, Typography } from "antd";
import { PaginationComponent } from "~Common/Pagination/PaginationComponent";
import { useHandlePagination } from "~hooks/useHandlePagination";
import TeamCoachStatsRow from "./TeamCoachStatsRow";
import { getPlayerAveragesColumns } from "./columnsRepository";

const TeamPlayerStatsTotal = (props) => {
  const { title, data, intl, team } = props;
  const { formatMessage } = intl;
  const { pageSize, currentPage, handlePaginationChange, pageSizeOptions } = useHandlePagination(1000);

  return (
    <>
      <Typography.Title level={4}>{title} - Player Averages</Typography.Title>
      <Table
        columns={getPlayerAveragesColumns({ formatMessage })}
        dataSource={data}
        size="small"
        pagination={{
          current: currentPage,
          defaultPageSize: pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          position: ["bottomCenter"],
          total: data?.length || 0,
          onChange: handlePaginationChange,
          showTotal: (total, range) => <PaginationComponent pageSize={pageSize} total={total} range={range} />,
          pageSizeOptions
        }}
        rowKey={"personId"}
        summary={() => {
          return <TeamCoachStatsRow result={team} includes={data.includes.resources} type={"averages"} />;
        }}
      />
    </>
  );
};

export default injectIntl(TeamPlayerStatsTotal);
